import React from 'react';
import PropTypes from 'prop-types';
import { Play, Pause, Refresh } from '@one-thd/sui-icons';
import classNames from 'classnames';

const VideoPlayButton = ({ handlePlayChange = () => {}, isPlaying = false, shouldShowReplay = false }) => {
  const videoButtonDefaultClasses = classNames(
    'sui-justify-center sui-items-center sui-bg-inactive sui-rounded-full sui-h-8 sui-w-8',
  );

  const playButtonClasses = classNames(
    'play-button',
    videoButtonDefaultClasses,
    { 'sui-flex': !isPlaying && !shouldShowReplay, 'sui-hidden': isPlaying || shouldShowReplay }
  );

  const pauseButtonClasses = classNames(
    'pause-button',
    videoButtonDefaultClasses,
    { 'sui-flex': isPlaying && !shouldShowReplay, 'sui-hidden': !isPlaying || shouldShowReplay }
  );

  const replayButtonClasses = classNames(
    'replay-button',
    videoButtonDefaultClasses,
    { 'sui-flex': shouldShowReplay, 'sui-hidden': !shouldShowReplay }
  );

  return (
    <div
      role="button"
      tabIndex={0}
      className="hero-video-button sui-absolute sui-top-4 sui-right-4 sui-flex sui-justify-end sui-items-end sui-z-10"
      aria-label="pause, replay or play video"
      aria-pressed={isPlaying}
      onClick={handlePlayChange}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          handlePlayChange(event);
        }
      }}
      onKeyUp={(event) => event.stopPropagation()}
    >
      <div data-testid="play-button" className={playButtonClasses}>
        <div className="play-button-hover sui-pl-1"><Play color="brand" size="small" /></div>
        <div className="play-button-no-hover sui-pl-1"><Play color="primary" size="small" /></div>
      </div>
      <div data-testid="pause-button" className={pauseButtonClasses}>
        <div className="pause-button-hover"><Pause color="brand" size="small" /></div>
        <div className="pause-button-no-hover"><Pause color="primary" size="small" /></div>
      </div>
      <div data-testid="replay-button" className={replayButtonClasses}>
        <div className="replay-button-hover"><Refresh color="brand" size="small" /></div>
        <div className="replay-button-no-hover"><Refresh color="primary" size="small" /></div>
      </div>
    </div>
  );
};

VideoPlayButton.propTypes = {
  handlePlayChange: PropTypes.func,
  isPlaying: PropTypes.bool,
  shouldShowReplay: PropTypes.bool,
};

VideoPlayButton.displayName = 'VideoPlayButton';

export { VideoPlayButton };